export const gitCommit = 'ef431f30'
